
    <div class="summary-wrapper">
      <div class="main-left">
        <h1>
          <img src="assets/images/long_arrow.svg" alt="long arrow icon" />
          Summary
        </h1>
    
        <ul class="package-box">
          <li>       
            <p><strong>{{getInvoiceType(invoiceType)}}</strong></p>
          </li>
        </ul>
    
        <ul class="price-details">
          <li><span><b>Amount</b></span> <span>AED {{invoiceAmount}}</span></li>
          <li><b>TotalAmount</b><b>AED {{invoiceAmount}}</b></li>
        </ul>
        <ul>
         <div class="add-card">
        <div class="add_new_card">
          <p>{{'AddNewCard'|translate}}</p>
        </div>

        <div style="margin: 15px 0px">
          <div id="card-element">
            <!-- Stripe Card Element will be mounted here -->
          </div>

          <div id="card-errors" role="alert"></div>
        </div>
      </div>
      </ul>
    
        <button class="btnn" (click)="payOut()">Pay Now</button>
      </div>
    
      <div class="main-right">
        <img src="assets/images/illustration.svg" alt="illustration Promo" />
        <h3>Don't miss out on mastering new skills</h3>
        <p>20% off your course enrollment today!</p>
        <button class="btnn">Buy Now</button>
      </div>
    </div>



